import { Row, Col, Radio, Badge } from "antd";
import AdnButton from "../common/adnButton/AdnButton";
import { MonthsAsNumbers } from "../common/GeneralConfigurations";
import { useTranslation } from "react-i18next";

const MontlyEventsCounterDashboard = ({
  monthlyEventsList,
  onRadioChange,
  handleMonthChange,
  handleColorChange,
  badgesColors,
}) => {
  const { t } = useTranslation();
  const badgeMaxNumber = 1000;

  const months = [
    { key: "jan", number: MonthsAsNumbers.January },
    { key: "feb", number: MonthsAsNumbers.February },
    { key: "mar", number: MonthsAsNumbers.March },
    { key: "apr", number: MonthsAsNumbers.April },
    { key: "may", number: MonthsAsNumbers.May },
    { key: "jun", number: MonthsAsNumbers.June },
    { key: "jul", number: MonthsAsNumbers.July },
    { key: "aug", number: MonthsAsNumbers.August },
    { key: "sep", number: MonthsAsNumbers.September },
    { key: "oct", number: MonthsAsNumbers.October },
    { key: "nov", number: MonthsAsNumbers.November },
    { key: "dec", number: MonthsAsNumbers.December },
  ];

  return (
    <>
      <Row
        gutter={12}
        justify="space-between"
        style={{ marginBottom: "1.5rem" }}
      >
        <Col>
          <h4>{t("monthlyEvents.title")}</h4>
        </Col>
        <Col className="radio-group-col">
          <Radio.Group
            onChange={onRadioChange}
            defaultValue="All"
            buttonStyle="solid"
            className="radio-group"
          >
            <Radio.Button value="All">{t("monthlyEvents.all")}</Radio.Button>
            <Radio.Button value="Done">{t("monthlyEvents.done")}</Radio.Button>
            <Radio.Button value="Not assigned">
              {t("monthlyEvents.notAssigned")}
            </Radio.Button>
            <Radio.Button value="Not done">
              {t("monthlyEvents.notDone")}
            </Radio.Button>
          </Radio.Group>
        </Col>
      </Row>

      <Row style={{ marginBottom: "1rem" }}>
        {months.map((month, index) => (
          <Col
            key={month.key}
            style={{
              paddingLeft: "1rem",
              paddingBottom: index > 0 ? "1rem" : "0",
            }}
            xs={{ span: 12 }}
            sm={{ span: 8 }}
            md={{ span: 4 }}
            lg={{ span: 4 }}
            xl={{ span: 2 }}
          >
            <Badge
              color={badgesColors[month.number - 1]}
              count={monthlyEventsList[month.number - 1]}
              showZero
              overflowCount={badgeMaxNumber}
            >
              <AdnButton
                style={{
                  background: handleColorChange(month.number),
                  borderColor: "white",
                  color: "white",
                  borderRadius: "10px",
                }}
                handleClick={() => handleMonthChange(month.number)}
                text={t(`common.monthsShort.${month.key}`)}
              />
            </Badge>
          </Col>
        ))}
      </Row>
    </>
  );
};

export default MontlyEventsCounterDashboard;
